import state from './home.state.js';
import getters from './home.getters.js';
// import actions from './home.actions.js';
import mutations from './home.mutations.js';

export default {
  state,
  getters,
  // actions,
  mutations
};
